import gql from 'graphql-tag'
import {userFragment} from '../fragments'

export const CreateTeacher = gql`
mutation CreateTeacher($managerId: ID, $userId: ID) {
  createTeacher(managerId: $managerId, userId: $userId) {
    teacher {
      id
      user {
        ...userFragment
      }
    }
  }
}
${userFragment}
`




export const UpdateTeacher = gql`
mutation UpdateTeacher($id: ID!, $managerId: ID, $userId: ID) {
  updateTeacher(id: $id,managerId: $managerId, userId: $userId) {
    teacher {
      id
      user {
        ...userFragment
      }
    }
  }
}
${userFragment}
`


export const DeleteTeacher = gql`
mutation DeleteTeacher($id: ID!) {
  deleteTeacher(id: $id) {
    id_
  }
}
`
